(() => {
  if (window.sweetbarCardAlignment) return;
  window.sweetbarCardAlignment = true;
  const gridSelector = '.product-grid, .sb-seasonal__products';
  let scheduled = false;
  const visible = (node) => node && node.getClientRects().length > 0;
  const align = () => {
    scheduled = false;
    document.querySelectorAll(gridSelector).forEach((grid) => {
      const cards = [...grid.querySelectorAll('[data-sb-card]')].filter((card) =>
        card.closest(gridSelector) === grid && !card.closest('quick-add-modal') && visible(card)
      );
      cards.forEach((card) => {
        card.style.removeProperty('--sb-title-height');
        card.style.removeProperty('--sb-price-offset');
        card.style.removeProperty('--sb-action-offset');
        card.style.removeProperty('--sb-action-height');
      });
      const rows = [];
      cards.forEach((card) => {
        // Layout offsets stay stable while scroll-reveal transforms are animating.
        const item = card.closest('.grid__item') || card;
        const top = item.offsetTop;
        let row = rows.find((entry) => Math.abs(entry.top - top) < 5);
        if (!row) { row = { top, cards: [] }; rows.push(row); }
        row.cards.push(card);
      });
      rows.forEach(({ cards: row }) => {
        if (grid.matches('.product-grid')) {
          const headings = row.map((card) => ({
            card,
            heading: card.matches('.sb-calendar-reference')
              ? card.querySelector('.sb-calendar-reference__title')
              : card.querySelector('.card > .card__content > .card__information > .card__heading')
          })).filter((entry) => visible(entry.heading));
          const headingHeight = Math.max(0, ...headings.map((entry) => entry.heading.getBoundingClientRect().height));
          headings.forEach((entry) => entry.card.style.setProperty('--sb-title-height', `${headingHeight}px`));
        }
        const entries = row.map((card) => ({
          card,
          price: card.querySelector('.sb-card-pricing'),
          action: card.querySelector('.quick-add__submit')
        })).filter((entry) => visible(entry.price));
        if (entries.length < 2) return;
        const top = (entry, element) => element.getBoundingClientRect().top - entry.card.getBoundingClientRect().top;
        const priceTops = entries.map((entry) => top(entry, entry.price));
        const maxPriceTop = Math.max(...priceTops);
        entries.forEach((entry, index) => entry.card.style.setProperty('--sb-price-offset', `${Math.max(0, maxPriceTop - priceTops[index])}px`));
        const actions = entries.filter((entry) => visible(entry.action));
        if (actions.length < 2) return;
        const actionHeight = Math.max(44, ...actions.map((entry) => entry.action.getBoundingClientRect().height));
        actions.forEach((entry) => entry.card.style.setProperty('--sb-action-height', `${actionHeight}px`));
        const actionTops = actions.map((entry) => top(entry, entry.action));
        const maxActionTop = Math.max(...actionTops);
        actions.forEach((entry, index) => entry.card.style.setProperty('--sb-action-offset', `${Math.max(0, maxActionTop - actionTops[index])}px`));
      });
    });
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(align);
  };
  const start = () => {
    schedule();
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule, { once: true });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('load', (event) => {
      if (event.target instanceof HTMLImageElement && event.target.closest(gridSelector)) schedule();
    }, true);
    new MutationObserver((records) => {
      if (records.some((record) => record.type === 'childList' && (record.addedNodes.length || record.removedNodes.length))) schedule();
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    if (document.fonts) document.fonts.ready.then(schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

